<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15.8215 10H11.4646V12H15.8215V10Z"
            fill-rule="evenodd"
            clip-rule="evenodd"
        />
        <path
            d="M11.4646 15H20.5354V17H11.4646V15Z"
            fill-rule="evenodd"
            clip-rule="evenodd"
        />
        <path
            d="M20.5354 20L11.4646 20V22L20.5354 22V20Z"
            fill-rule="evenodd"
            clip-rule="evenodd"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7 7C7 5.89543 7.89543 5 9 5H23C24.1046 5 25 5.89543 25 7V25C25 26.1046 24.1046 27 23 27H9C7.89543 27 7 26.1046 7 25V7ZM9 7H23V25H9L9 7Z"
        />
    </svg>
</template>
